import { Button, Col, Form, Row, Select, notification } from "antd";
import React, { useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";

const jobStatusOptions = [
	{ value: "Trouble", label: "Trouble" },
	{ value: "ok", label: "Poured" },
	{ value: "Confirm", label: "A/R Confirmed" },
	{ value: "Operations done (AR)", label: "Operations done (AR)" },
	{
		value: "Scheduled",
		label: "Scheduled",
	},
	{ value: "Inactive", label: "Inactive" },
	{ value: "Company cancellation", label: "Company cancellation" },
	{ value: "Customer cancellation", label: "Customer cancellation" },
	{ value: "Date moved", label: "Date moved" },
	{ value: "Active", label: "Pouring" },
	{ value: "Ready to Load", label: "Ready to be scheduled" },
	{ value: "Quote", label: "Quote" },
	{ value: "Waiting Inspection", label: "Waiting Inspection" },
];

const ApprovedPriceByStatus = ({ today, plant, subplant, onSuccess }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const updateJobs = async (datas) => {
		try {
			setLoading(true);

			const url =
				api +
				`/job/update/all/approvedPrice?date=${today}&plant=${plant}&subplant=${subplant}&jobStatus=${datas.jobStatus}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url);
			if (data.success) {
				openNotification("success", "Success", data.message);
				setTimeout(() => {
					form.resetFields();
					setLoading(false);
					onSuccess();
				}, 1000);
			} else {
				form.resetFields();
				setLoading(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to updating jobs");
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		updateJobs(values);
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const CustomForm = () => {
		return (
			<Form form={form} layout="vertical" onFinish={onFinish}>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item
							label="Job Status"
							name="jobStatus"
							rules={[
								{
									required: true,
									message: "Please select a status",
								},
							]}
						>
							<Select
								style={{
									width: "100%",
								}}
								size="large"
								placeholder="Please select job status"
								options={jobStatusOptions}
								loading={loading}
								optionFilterProp="children"
								showSearch
								filterOption={filterOption}
							/>
						</Form.Item>
					</Col>
				</Row>

				<Button type="primary" htmlType="submit" loading={loading} size="large">
					Update
				</Button>
			</Form>
		);
	};

	return (
		<>
			{contextHolder}
			<CustomForm />
		</>
	);
};

export default ApprovedPriceByStatus;
